import React from 'react';

const NavRightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g
        id="icons/24/caret-right"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <polyline
          id="Path"
          stroke="#F2F5F8"
          transform="translate(9.250000, 12.250000) rotate(-45.000000) translate(-9.250000, -12.250000) "
          points="15.4749241 6 15.5 18.5 3 18.4749241"
        />
      </g>
    </svg>
  );
};

export default NavRightIcon;
